import gql from 'graphql-tag'
import { PRODUCT_REFERENCE_FRAGMENT } from './fragments.graphql'

export const GET_PRODUCTS_BY_CATEGORY_PATH = gql`
  ${PRODUCT_REFERENCE_FRAGMENT}

  query GetProductsByCategoryPath(
    $categoryPath: String!
    $selectedFacets: [FacetParameterInput!]
    $numberOfProducts: Int!
    $searchPhrase: String
    $sortBy: SortBy
  ) {
    productSearchByCategoryPath(
      searchPhrase: $searchPhrase
      sortBy: $sortBy
      page: 1
      pageSize: $numberOfProducts
      facets: $selectedFacets
      categoryPath: $categoryPath
    ) {
      productReferences {
        ...ProductReference
      }
    }
  }
`
